import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="offer-toggle"
export default class extends Controller {
  static values = { url: String }

  toggle() {
    const checkbox = this.element
    checkbox.disabled = true

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: null
    })
      .then(response => response.text())
      .then(turboStream => Turbo.renderStreamMessage(turboStream))
      .catch(e => console.error(e))
      .finally(() => checkbox.disabled = false)
  }
}
